export default __webpack_public_path__ + "static/media/cart-white.52bdd46d.svg";